/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Open supervision-absence interval on the time slot (lecturer aggregate only).
 */
export interface OralExamSupervisionAbsenceResponse {
  startedAt: string;
  deadlineAt: string;
}
